import { ServiceIdentifier } from '../service-locator';
import { IlluminateService } from './interfaces';

export * from './interfaces';

export const ILLUMINATE_SERVICE = ServiceIdentifier.get<IlluminateService>('IlluminateService');
